/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Team_Created_SuccessInputs */



/**
* | output |
* | --- |
* | "New team created successfully" |
*
* @param {Team_Manager_Team_Created_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_team_created_success = /** @type {((inputs?: Team_Manager_Team_Created_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Team_Created_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle équipe créée avec succès")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neues Team erfolgreich gebildet")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo team creato con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новая команда успешно создана")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo equipo creado exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新团队已成功组建。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいチームが正常に作成されました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नई टीम का गठन सफलतापूर्वक हो गया है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nova equipe criada com sucesso")
	return /** @type {LocalizedString} */ ("New team created successfully")
});